import React from 'react';
import {
  Datagrid,
  FunctionField,
  NumberField,
  ReferenceManyField,
  useRefresh,
  TextField,
  useDataProvider,
} from 'react-admin';
import CreateButton from 'Resources/PlotEvidence/QuickCreate';
import EditButton from 'Resources/PlotEvidence/QuickEdit';
import { Pagination } from 'Components';
import { tabbedLists } from 'styles';
import { Button } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/pro-regular-svg-icons';
import getToken from 'utils/getToken';
import axios from 'axios';

const EvidenceTab = (props) => {
  const classes = tabbedLists();
  const refresh = useRefresh();
  const { record } = props;

  const dataProvider = useDataProvider();


  const handlePrintAllEvidence = async () => {
    const token = await getToken();

    var query = `query allPlotEvidences($page: Int, $perPage: Int, $sortField: String, $sortOrder: String, $filter: PlotEvidenceFilter) {\n  items: allPlotEvidences(\n    page: $page\n    perPage: $perPage\n    sortField: $sortField\n    sortOrder: $sortOrder\n    filter: $filter\n  ) {\n    id\n    plotId\n    evidenceId {\n      id\n      name\n      pdf {\n        url\n        __typename\n      }\n      __typename\n    }\n    folderNumber\n    orderIndex\n    requiredActors\n    createdAt\n    updatedAt\n    deletedAt\n    __typename\n  }\n  total: _allPlotEvidencesMeta(page: $page, perPage: $perPage, filter: $filter) {\n    count\n    __typename\n  }\n}`


    axios({
      url: process.env.REACT_APP_GRAPHQL_URI,
      method: 'post',
      data: {
        operationName: 'allPlotEvidences',
        query: query,
        variables: {
          page: 0,
          perPage: 1000,
          sortField: 'orderIndex',
          sortOrder: 'ASC',
          filter: {
            plotId: props.record.id,
          },
        },
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      console.log(res.data.data.items);

      const pdfUrls = res.data.data.items.map((record) => record.evidenceId.pdf?.url).filter((url) => url !== undefined);
      pdfUrls.forEach((url) => window.open(url));
    }).catch((err) => {
      console.log(err.message);
    });
  }

  return (
    <>
      <div className={classes.actions}>
        <CreateButton record={record} onChange={() => refresh()} />
        <Button style={{
          marginTop: '2%',
          fontSize: '13px',
          color: '#243f56',
        }}
          onClick={handlePrintAllEvidence}>
          <FontAwesomeIcon icon={faPrint} /> &nbsp; Print all evidence
        </Button>
      </div>
      <ReferenceManyField
        reference="plotEvidence"
        target="plotId"
        source="id"
        sort={{ field: 'orderIndex', order: 'ASC' }}
        pagination={<Pagination />}
        perPage={50}
      >
        <Datagrid>
          <TextField
            label="Evidence Name"
            source="evidenceId.name"
            sortable={false}
          />

          <NumberField source="folderNumber" />
          <NumberField source="orderIndex" sortable={false} />
          <NumberField source="requiredActors" sortable={false} />
          <FunctionField render={(record) => <EditButton record={record} />} />
        </Datagrid>
      </ReferenceManyField>
    </>
  );
};

export default EvidenceTab;
